import { apiClient } from './apiClient';

export interface CalendarTokenResponse {
  token: string;
  calendarUrl: string;
  instructions: {
    googleCalendar: string;
    outlook: string;
    appleCalendar: string;
  };
}

export const calendarService = {
  async getCalendarToken(): Promise<CalendarTokenResponse> {
    const response = await apiClient.get('/calendar/token');
    return response.data;
  },

  async generateNewCalendarToken(): Promise<CalendarTokenResponse> {
    const response = await apiClient.post('/calendar/token/generate');
    return response.data;
  },

  async revokeCalendarToken(): Promise<void> {
    await apiClient.post('/calendar/token/revoke');
  }
};
